<template>
  <div class="wm-problem">
    <pageHeader title="常见问题" />
    <div class="gray-box"></div>

    <div class="problem-container">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="———— 暂时就这些问题 ————"
        @load="onLoad"
      >
        <div class="problem-item" @click="item.isExpanded = !item.isExpanded" v-for="(item, i) in problemList" :key="i">
          <div class="question">
            <h1>Q{{ i + 1 }}：{{ item.title }}</h1>
            <img
              :src="
                item.isExpanded
                  ? require('@/assets/images/icon-top.png')
                  : require('@/assets/images/icon-down.png')
              "
              alt=""
            />
          </div>
          <div class="answer">
            <p :class="[item.isExpanded ? 'expand-answer' : '']">
              {{ item.answer }}
            </p>
          </div>
        </div>
      </van-list>
    </div>
    <div class="leaveMsg-btn" @click="gotoLeaveMsg">我要留言</div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import { requestMethods } from "@m/api";
export default {
  components: {
    pageHeader,
  },
  data() {
    return {
      problemList: [],
      loading: false,
      finished: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  methods: {
    async onLoad() {
      this.loading = true;
      const { data, totalCount } = await this.getproblemList();

      const list = data.map((e) => {
        return {
          ...e,
          isExpanded: false,
        };
      });

      this.problemList = [...this.problemList, ...list];
      this.totalCount = totalCount;
      this.totalPage = Math.ceil(this.totalCount / this.pageSize);
      // 数据全部加载完成
      if (this.currentPage >= this.totalPage) {
        this.finished = true;
      }
      this.currentPage += 1;

      this.loading = false;
    },
    /**
     * 获取消息列表
     */
    async getproblemList() {
      try {
        const { data, totalCount } = await requestMethods(
          "/modules/common/question/getSysQuestionList.htm",
          "post",
          {
            currentPage: this.currentPage,
            pageSize: this.pageSize,
          }
        );
        return {
          data: data,
          totalCount: totalCount,
        };
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },

    gotoLeaveMsg() {
        this.$router.push({
            path: '/leaveMsg'
        })
    }
  },
};
</script>

<style lang="scss">
.wm-problem {
  .gray-box {
    background: #f4f4f4;
    height: 10px;
    width: 100%;
  }
  .problem-container {
    padding: 40px;
    padding-top: 0;
    padding-bottom: 100px;

    .van-list__finished-text {
        background: #F4F4F4;
        line-height: 70px;
    }

    .problem-item {
      margin: 20px 0;

      .question {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        h1 {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 28px;
          color: #333333;
          line-height: 36px;
        }

        img {
          width: 27px;
          height: 26px;
        }
      }
      .answer {
        padding-left: 40px;
        margin-top: 20px;
        p {
          font-family: PingFang SC;
          font-weight: 500;
          font-size: 28px;
          color: #999999;
          line-height: 50px;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .expand-answer {
          white-space: normal;
        }
      }

      //   &:last-child {
      //     margin: 0px;
      //   }
    }
  }
  .leaveMsg-btn {
    position: fixed;
    bottom: 10px;
    left: 40px;
    width: 640px;
    height: 80px;
    background: #ff7a3e;
    border-radius: 40px;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 28px;
    color: #ffffff;
    text-align: center;
    line-height: 80px;
    
  }
}
</style>


// WEBPACK FOOTER //
// src/views/problem/index.vue